module.exports = __webpack_public_path__ + "static/img/xl31.a818497.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/xl31.png
// module id = ujlI
// module chunks = 73